import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=ffe5164a&scoped=true&"
import script from "./GoBack.vue?vue&type=script&lang=js&"
export * from "./GoBack.vue?vue&type=script&lang=js&"
import style0 from "./GoBack.vue?vue&type=style&index=0&id=ffe5164a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe5164a",
  null
  
)

export default component.exports